var styles = {
  "Listbox": "Polaris-Listbox"
};

export { styles as default };
